import React from 'react'
import {Col, Container, Row} from '@modifi/ui'
import {Helmet} from 'react-helmet'
import {translate, KEY_JANUS} from '@modifi/plugin-i18n'
import {compose} from 'ramda'
import PropTypes from 'prop-types'

import {TRACK_CATEGORY_SIGN_UP} from '../../../../constants/tracking'
import SignUpForm from '../sign-up-form'
import {ImageCol, StyledPicture, Wrapper} from './styles'

const SignUp = ({t}) => (
  <Wrapper>
    <Helmet>
      <title>{t('content.signup.title')}</title>
      <meta name="description" content={t('content.signup.meta-description')} />
      <meta name="keywords" content={t('content.signup.meta-keywords')} />
      <body data-track-category={TRACK_CATEGORY_SIGN_UP} />
    </Helmet>
    <Container>
      <Row>
        <ImageCol lg={5} hiddenLgDown>
          <StyledPicture alt="2 professionals in a manufacturing plant" name="SignUpImgs" />
        </ImageCol>
        <Col lg={6} lgOffset={1} mt={64} mdMt={0}>
          <SignUpForm title={t('content.signup.headline')} />
        </Col>
      </Row>
    </Container>
  </Wrapper>
)

SignUp.propTypes = {
  t: PropTypes.func.isRequired,
}

export default compose(translate(KEY_JANUS))(SignUp)
